import { Zap, Thermometer, Flame, Waves, Droplet } from "lucide-react"

const RESOURCE_META_RAW = {
  water: {
    imgSrc: "/images/apt-overview-water.png",
    unit: "m³",
    label: { ko: "수도", en: "Water", es: "Agua" },
    icon: Droplet,
    colors: {
      text: "text-blue-400",
      groupHoverText: "group-hover:text-blue-400",
      iconBg: "bg-[#EFF6FF]",
      chartColor: "#0EA5E9",
      rankBg: "bg-sky-500",
      rankBulletHover: "hover:bg-sky-500",
      primary: "#0EA5E9",
      light: "#EFF6FF"
    },
    leak: {
      colors: {
        primary: "#EF4444",
        light: "#FEF2F2"
      }
    }
  },
  hotwater: {
    imgSrc: "/images/apt-overview-hotwater.png",
    unit: "m³",
    label: { ko: "온수", en: "Hot water", es: "Agua caliente" },
    icon: Waves,
    colors: {
      text: "text-orange-400",
      groupHoverText: "group-hover:text-orange-400",
      iconBg: "bg-[#FFF7ED]",
      chartColor: "#F97316",
      rankBg: "bg-orange-500",
      rankBulletHover: "hover:bg-orange-500",
      primary: "#F97316",
      light: "#FFF7ED"
    }
  },
  elect: {
    imgSrc: "/images/apt-overview-elect.png",
    unit: "kWh",
    label: { ko: "전기", en: "Electricity", es: "Electricidad" },
    icon: Zap,
    colors: {
      text: "text-amber-400",
      groupHoverText: "group-hover:text-amber-400",
      iconBg: "bg-[#FEFCE8]",
      chartColor: "#F59E0B",
      rankBg: "bg-amber-300",
      rankBulletHover: "hover:bg-amber-300",
      primary: "#FDCD5D",
      light: "#FEFCE8"
    }
  },
  gas: {
    imgSrc: "/images/apt-overview-gas.png",
    unit: "m³",
    label: { ko: "가스", en: "Gas", es: "Gas" },
    icon: Flame,
    colors: {
      text: "text-emerald-400",
      groupHoverText: "group-hover:text-emerald-400",
      iconBg: "bg-[#F0FDFA]",
      chartColor: "#14B8A6",
      rankBg: "bg-teal-500",
      rankBulletHover: "hover:bg-teal-500",
      primary: "#14B8A6",
      light: "#F0FDFA"
    }
  },
  hot: {
    imgSrc: "/images/apt-overview-hot.png",
    unit: "kWh",
    label: { ko: "난방", en: "Heating", es: "Calefaccion" },
    icon: Thermometer,
    colors: {
      text: "text-purple-400",
      groupHoverText: "group-hover:text-purple-400",
      iconBg: "bg-[#F5F3FF]",
      chartColor: "#8B5CF6",
      rankBg: "bg-violet-500",
      rankBulletHover: "hover:bg-violet-500",
      primary: "#8B5CF6",
      light: "#F5F3FF"
    }
  }
}

export const RESOURCE_COLOR_MAP = {
  water: "#0EA5E9",
  leak: "#EF4444",
  hotwater: "#F97316",
  elect: "#F59E0B",
  gas: "#14b8a6",
  hot: "#8B5CF6"
}

export const RESOURCE_META = { ...RESOURCE_META_RAW }
export const RESOURCE_KEYS = Object.keys(RESOURCE_META)

export const RESOURCE_KPI_METRICS = RESOURCE_KEYS.map((key) => ({
  key,
  label: RESOURCE_META[key].label,
  imgSrc: RESOURCE_META[key].imgSrc,
  iconBg: RESOURCE_META[key].colors.iconBg,
  text: RESOURCE_META[key].colors.text,
  value: 0,
  diff: "-%"
}))

export const RESOURCE_TREND_CARDS = RESOURCE_KEYS.map((key) => ({
  key,
  label: RESOURCE_META[key].label,
  imgSrc: RESOURCE_META[key].imgSrc,
  color: RESOURCE_META[key].colors.chartColor
}))

export const RESOURCES = RESOURCE_KEYS.map((key) => ({
  id: key,
  ...RESOURCE_META[key]
}))
